// extracted by mini-css-extract-plugin
export var root = "BlogContent-module--root--dd472";